import React, { useEffect } from "react";
import Header from "../../Components/Header";
import CourseTemplate from "../../Components/Course/CourseTemplate";
import CourseTemp from "../../Components/Course/CourseTemp";

export default function Course() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Header />
      <CourseTemplate />
      {/* <CourseTemp /> */}
    </div>
  );
}
